import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import {
	InputLabel,
	Input,
	InputAdornment,
	IconButton,
	Typography,
	Button,
	FormHelperText,
	Link,
	Box,
} from '@material-ui/core';
import { useSnackbar } from 'notistack';
import AlertDialog from '../../Common/Dialog';
import { clearLocalStorage, getLocalStorageItem } from '../../../services/StorageService';
import { LockIcon } from '../../../config/svg/CommonSvg';
import { AZURE_LOGOUTURI } from '../../../config/constant';
import { ErrorIcon } from '../../../config/svg/formElementIcons';
import { validatePassword } from '../../../config/utils';
import { useAuth } from 'react-oidc-context';
import { LOGOUT_INITIATOR_URL } from '../../../config/app-url';

export default function ChangePassword(props) {
	const auth = useAuth();
	const userDetail = JSON.parse(getLocalStorageItem('userDetail'));
	const [showOldPassword, setShowOldPassword] = useState(false);
	const [showNewPassword, setShowNewPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);
	const { enqueueSnackbar } = useSnackbar();
	const [isFormSubmit, setIsFormSubmit] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const initialData = {
		oldPassword: '',
		newPassword: '',
		confirmPassword: '',
		isNewPasswordValid: false,
		isConfirmPasswordValid: false,
		formValid: false,
		disabled: userDetail.ssoLogin ? userDetail.ssoLogin : false,
	};
	const [formData, setFormData] = useState(initialData);
	const { t } = useTranslation();

	const handleDrawerConfirmation = () => {
		if (JSON.stringify(formData) !== JSON.stringify(initialData)) {
			props.setModalProps({
				open: true,
				type: 'closeDrawer',
				message: t('unSavedItemAlert'),
				module: 'profile',
			});
		} else {
			props.setProfileOpen(false);
		}
	};

	const handleCloseModal = (e, type) => {
		e.preventDefault();
		if (type === 1) {
			submitRequest(e, 2);
		}
		setModalOpen(false);
	};

	const handleChange = (event, prop) => {
		const value = event.target.value;
		let valueObject = { ...formData };
		props.setFormDataUpdated(true);
		if (prop === 'oldPassword') {
			valueObject = {
				...valueObject,
				oldPassword: value.trim(),
				formValid:
					value && value.trim() && value.trim() && valueObject.isConfirmPasswordValid && valueObject.isNewPasswordValid,
			};
		} else if (prop === 'newPassword') {
			// let psdValid = value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/) ? true : false;
			const psdValid = validatePassword(value);
			valueObject = {
				...valueObject,
				newPassword: value.trim(),
				isNewPasswordValid: psdValid,
				isConfirmPasswordValid: valueObject.confirmPassword === value.trim(),
				formValid:
					valueObject?.oldPassword &&
					valueObject?.oldPassword?.trim() &&
					value.trim() &&
					valueObject.confirmPassword === value.trim() &&
					psdValid,
			};
		} else if (prop === 'confirmPassword') {
			valueObject = {
				...valueObject,
				confirmPassword: value.trim(),
				isConfirmPasswordValid: valueObject.newPassword === value.trim(),
				formValid:
					valueObject?.oldPassword &&
					valueObject?.oldPassword?.trim() &&
					valueObject.isNewPasswordValid &&
					value.trim() &&
					valueObject.newPassword === value.trim(),
			};
		} else {
			valueObject = { ...valueObject, [prop]: event.target.value };
		}
		setFormData({ ...valueObject });
	};

	const submitRequest = async (e, type) => {
		e.preventDefault();
		setIsFormSubmit(true);
		if (formData.formValid) {
			let data = {
				employeeId: formData.employeeId,
				oldPassword: formData.oldPassword,
				newPassword: formData.newPassword,
			};
			props.setLoader(true);
			let resp = await props.updateProfilePassword(data);
			if (resp.data.status === 200) {
				props.setLoader(false);
				enqueueSnackbar(t('successfullyUpdatedPassword'), { variant: 'success', autoHideDuration: 5000 });
				props.setProfileOpen(false);
				/*=== Logout User =====*/
				logoutUser();
			} else {
				props.setLoader(false);
				const responseAPI = resp.data.messageList;
				const keys = Object.keys(responseAPI);
				const messages = keys.map((item) => responseAPI[item]);
				enqueueSnackbar(`${messages} `, { variant: 'error', autoHideDuration: 5000 });
			}
		}
	};

	const logoutUser = () => {
		const isSSO = getLocalStorageItem('isSSO');
		const idpId = getLocalStorageItem('idpId');
		if (isSSO === 'false') {
			window.location.href = window.location.origin + LOGOUT_INITIATOR_URL;
		} else if (idpId === '3') {
			//Google Login
			clearLocalStorage();
			sessionStorage.clear();
			window.open('https://accounts.google.com/logout', '', 'width=100,height=100');
			window.location.href = window.location.origin + LOGOUT_INITIATOR_URL;
		} else {
			auth.removeUser();
			auth.signoutRedirect();
		}
		clearLocalStorage();
		sessionStorage.clear();
	};

	return (
		<Fragment>
			<Box className='drawer-content'>
				<Box className='drawer-inner-content'>
					<Box className='drawer-content-panel'>
						<Box className='password-wrapper'>
							<form className='drawer-form-fields reset-password-forminfo drawer-form-fields'>
								<Box className='drawer-field-row title-wrapper'>
									<Typography className='title' variant='h3'>
										{t('resetPassword')}
									</Typography>
									{formData.disabled && <Typography variant='body2'>{t('ChangePasswordText')}</Typography>}
								</Box>
								<Box className='input-group-wrapper'>
									<Box className='drawer-input-field'>
										<InputLabel htmlFor='profile-oldpassword' className='first-lbl'>
											{t('oldPassword')}
										</InputLabel>
										<Input
											fullWidth={true}
											id='profile-oldpassword'
											type={showOldPassword ? 'text' : 'password'}
											value={formData.oldPassword}
											onChange={(e) => handleChange(e, 'oldPassword')}
											startAdornment={
												<InputAdornment position='start'>
													<LockIcon />
												</InputAdornment>
											}
											endAdornment={
												<InputAdornment position='end'>
													<IconButton
														aria-label={t('ResetPasswordInputAriaLabel')}
														onClick={() => setShowOldPassword(!showOldPassword)}
														disableRipple='true'
													>
														{showOldPassword ? <Link>{t('hideBtn')}</Link> : <Link>{t('showBtn')}</Link>}
													</IconButton>
												</InputAdornment>
											}
											disabled={formData.disabled}
										/>
									</Box>
									<Box className='drawer-input-field'>
										<InputLabel htmlFor='profile-newpassword'>{t('newPassword')}</InputLabel>
										<Box className='helperText-bottom'>
											<Input
												fullWidth={true}
												id='profile-newpassword'
												type={showNewPassword ? 'text' : 'password'}
												value={formData.newPassword}
												onChange={(e) => handleChange(e, 'newPassword')}
												startAdornment={
													<InputAdornment position='start'>
														<LockIcon />
													</InputAdornment>
												}
												endAdornment={
													<InputAdornment position='end'>
														<IconButton
															aria-label={t('ResetPasswordInputAriaLabel')}
															onClick={() => setShowNewPassword(!showNewPassword)}
															disableRipple='true'
														>
															{showNewPassword ? <Link>{t('hideBtn')}</Link> : <Link>{t('showBtn')}</Link>}
														</IconButton>
													</InputAdornment>
												}
												disabled={formData.disabled}
												error={isFormSubmit && !formData.isNewPasswordValid}
											/>
											{isFormSubmit && !formData.isNewPasswordValid && (
												<FormHelperText>
													<ErrorIcon />
													{t('strongPassword')}
												</FormHelperText>
											)}
										</Box>
									</Box>
									<Box className='drawer-input-field '>
										<InputLabel htmlFor='profile-confirmpassword'>{t('confirmPassword')}</InputLabel>
										<Box className='helperText-bottom'>
											<Input
												className={
													formData.newPassword === formData.confirmPassword &&
													formData.newPassword &&
													formData.confirmPassword
														? 'valid'
														: formData.newPassword &&
														  formData.confirmPassword &&
														  formData.newPassword !== formData.confirmPassword
														? 'invalid'
														: ''
												}
												fullWidth={true}
												id='profile-confirmpassword'
												type={showConfirmPassword ? 'text' : 'password'}
												value={formData.confirmPassword}
												onChange={(e) => handleChange(e, 'confirmPassword')}
												startAdornment={
													<InputAdornment position='start'>
														<LockIcon />
													</InputAdornment>
												}
												endAdornment={
													<InputAdornment position='end'>
														<IconButton
															aria-label={t('ResetPasswordInputAriaLabel')}
															onClick={() => setShowConfirmPassword(!showConfirmPassword)}
															disableRipple='true'
														>
															{showConfirmPassword ? <Link>{t('hideBtn')}</Link> : <Link>{t('showBtn')}</Link>}
														</IconButton>
													</InputAdornment>
												}
												disabled={formData.disabled}
												error={isFormSubmit && !formData.isConfirmPasswordValid}
											/>
											{isFormSubmit && !formData.isConfirmPasswordValid && (
												<FormHelperText>
													<ErrorIcon />
													{t('passwordNotMatch')}
												</FormHelperText>
											)}
										</Box>
										{/* </FormControl> */}
									</Box>
								</Box>
							</form>
						</Box>
					</Box>
				</Box>
			</Box>
			<Box className='drawer-footer-actions'>
				<Button
					className='cancel-btn btn-link'
					color='primary'
					onClick={handleDrawerConfirmation}
					disabled={formData.disabled}
				>
					{t('cancelBtn')}
				</Button>
				<Button
					className='submitBtn btn-primary save-btn'
					color='primary'
					onClick={() => setModalOpen(true)}
					disabled={formData.disabled}
				>
					{t('saveChangesBtn')}
				</Button>
			</Box>
			{modalOpen && (
				<AlertDialog
					module='changePassword'
					message={t('ChangePasswordConfirmation')}
					handleCloseModal={handleCloseModal}
					modalOpen={modalOpen}
				/>
			)}
		</Fragment>
	);
}
